import type { ImgHTMLAttributes } from "react";
import skoolIcon from "@/assets/skool-icon.png";

/** Skool brand mark (official favicon from skool.com, background made transparent). */
export function SkoolIcon({ className, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  return <img src={skoolIcon} alt="" aria-hidden="true" className={className} {...props} />;
}
